import React from 'react';
import Tooltip from '@atlaskit/tooltip';

import {
  formatErrorBudget,
  getErrorBudget,
} from '@/components/composed/new-slo-views/common/utils';
import { HeroNumber, HeroNumberProps, KeyValue } from '@/components/primitive';
import { formatDateForDisplay } from '@/utils';
import { DateDisplayFormats } from '@/constants';

import {
  formatPerformanceResult,
  getHeroNumberColorStyles,
  formatObjectiveResult,
  SLINumberProps,
} from './utils';

export const SLINumber: React.FC<SLINumberProps & HeroNumberProps> = ({
  performance,
  objective,
  isSkeleton,
}) => {
  const result = performance && performance.result;

  let text = '';

  if (result) {
    const successCriteria = result * 100 > objective;
    text = successCriteria
      ? `This SLO meets the Objective of ${objective}%.`
      : `This SLO is currently breaching ${objective}%.`;
  }

  return (
    <Tooltip content={text}>
      <HeroNumber
        isSkeleton={isSkeleton}
        css={getHeroNumberColorStyles({ performance, objective })}
      >
        {formatPerformanceResult(performance && performance.result)}
      </HeroNumber>
    </Tooltip>
  );
};

export const SLONumber: React.FC<SLINumberProps & HeroNumberProps> = ({
  objective,
  isSkeleton,
}) => <HeroNumber isSkeleton={isSkeleton}>{formatObjectiveResult(objective)}</HeroNumber>;

export const LatestData: React.FC<SLINumberProps> = ({ performance }) => (
  <KeyValue title="Latest Data">
    <code>
      {performance && performance.latestDataPointTimestamp
        ? formatDateForDisplay(
            performance.latestDataPointTimestamp,
            DateDisplayFormats.TIME_WITH_NUMERIC_DATE
          )
        : 'N/A'}
    </code>
  </KeyValue>
);

export const ErrorBudgetNumber: React.FC<SLINumberProps & HeroNumberProps> = ({
  performance,
  objective,
  isSkeleton,
}) => {
  const result = performance?.result;
  if (!result) return null;

  return (
    <HeroNumber isSkeleton={isSkeleton}>
      {formatErrorBudget(getErrorBudget(result, objective))}
    </HeroNumber>
  );
};
